import styled from 'styled-components'
import { device } from '@/common/constants/device'

export const PremiumText = styled.div`
  font-size: ${(props) => `${props.fontSizeMobile}px`};
  line-height: 1.2em;
  color: ${(props) => (props.color ? `var(--${props.color})` : 'var(--white)')};
  font-weight: 600;

  @media ${device.tablet} {
    font-size: 24px;
    line-height: 1.2em;
  }
`

export const PremiumLabel = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  background: ${(props) =>
    props.bgColor ? props.bgColor : 'rgba(245, 227, 65, 0.1)'};
  text-align: center;
  font-size: 12px;
  line-height: 1.5em;
  color: ${(props) =>
    props.color ? `var(--${props.color})` : 'var(--yellow)'};
  border-radius: 27px;

  @media ${device.tablet} {
    font-size: 16px;
    line-height: 1.5em;
  }
`
